import React from "react";
import ReportConfigList, {
  FREQUENCIA,
  TIPO_EXCEL,
} from "../../../../components/ReportConfig/ReportConfigList";
import EmailConfigManager from "../../../../components/EmailConfigManager/EmailConfigManager";
import {
  SHOW_LEGACY_REPORTS,
  HIGH_SPEED_OPTIONS,
  HIGH_SPEED_TYPE_OPTIONS,
  OTHER_REPORT_IDS,
} from "../constants";

export default function OtherReportsCard({
  reportItems,
  initialReportConfig,
  reportConfigPayload,
  setReportConfigPayload,
  relatorios,
  setRelatorios,
  visitFlag,
  setVisitFlag,
  fenceFlag,
  setFenceFlag,
  riskAreaFlag,
  setRiskAreaFlag,
  vehicleGroupId,
  reportTypes,
  emailsByReport,
  setEmailsByReport,
  loadingButtons,
  setLoadingButtons,
  fetchEmails,
}) {
  const getReportConfigById = (reportId) =>
    reportConfigPayload.find((item) => item.id === reportId) || {};

  const updateReportConfigById = (reportId, nextValues) => {
    setReportConfigPayload((prev) =>
      prev.some((item) => item.id === reportId)
        ? prev.map((item) =>
            item.id === reportId ? { ...item, ...nextValues } : item
          )
        : [...prev, { id: reportId, ativo: true, ...nextValues }]
    );
  };

  const emailManagerProps = {
    vehicleGroupId,
    reportTypes,
    emailsByReport,
    setEmailsByReport,
    loadingButtons,
    setLoadingButtons,
    fetchEmails,
  };

  const renderEmailManager = (reportKey) => (
    <EmailConfigManager reportKey={reportKey} {...emailManagerProps} />
  );

  // Recuo padrão dos blocos abaixo do toggle: minWidth(36) + gap(12) = 48
  const CONTENT_INDENT = 48;

  const renderReportFrequencyControls = (reportId) => {
    const currentConfig = getReportConfigById(reportId);
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          flexWrap: "wrap",
          marginTop: 10,
          marginLeft: CONTENT_INDENT,
        }}
      >
        <span>Frequência:</span>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name={`frequencia-radio-${reportId}`}
            id={`frequencia-diario-${reportId}`}
            checked={
              (currentConfig.frequencia || FREQUENCIA.DIARIO) === FREQUENCIA.DIARIO
            }
            onChange={() =>
              updateReportConfigById(reportId, { frequencia: FREQUENCIA.DIARIO })
            }
          />
          <label htmlFor={`frequencia-diario-${reportId}`} className="form-check-label">
            Diário
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name={`frequencia-radio-${reportId}`}
            id={`frequencia-semanal-${reportId}`}
            checked={currentConfig.frequencia === FREQUENCIA.SEMANAL}
            onChange={() =>
              updateReportConfigById(reportId, { frequencia: FREQUENCIA.SEMANAL })
            }
          />
          <label htmlFor={`frequencia-semanal-${reportId}`} className="form-check-label">
            Semanal
          </label>
        </div>
      </div>
    );
  };

  const renderReportExcelControls = (reportId) => {
    const currentConfig = getReportConfigById(reportId);
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          flexWrap: "wrap",
          marginLeft: CONTENT_INDENT,
          marginTop: 10,
        }}
      >
        <span>Excel:</span>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name={`excel-radio-${reportId}`}
            id={`excel-aba-unica-${reportId}`}
            checked={
              (currentConfig.tipoExcel || TIPO_EXCEL.ABA_UNICA) === TIPO_EXCEL.ABA_UNICA
            }
            onChange={() =>
              updateReportConfigById(reportId, { tipoExcel: TIPO_EXCEL.ABA_UNICA })
            }
          />
          <label htmlFor={`excel-aba-unica-${reportId}`} className="form-check-label">
            Aba única
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name={`excel-radio-${reportId}`}
            id={`excel-abas-separadas-${reportId}`}
            checked={currentConfig.tipoExcel === TIPO_EXCEL.ABAS_SEPARADAS}
            onChange={() =>
              updateReportConfigById(reportId, { tipoExcel: TIPO_EXCEL.ABAS_SEPARADAS })
            }
          />
          <label htmlFor={`excel-abas-separadas-${reportId}`} className="form-check-label">
            Abas separadas
          </label>
        </div>
      </div>
    );
  };

  const renderHighSpeedControls = (reportId) => {
    const currentConfig = getReportConfigById(reportId);
    const selectedSpeed = currentConfig.speedHigh ?? 30;
    const selectedType = currentConfig.typeHigh ?? 1;

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 28,
          alignItems: "flex-start",
          flexWrap: "wrap",
          marginLeft: CONTENT_INDENT,
          marginTop: 10,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <span>Velocidade:</span>
          <select
            className="form-select"
            style={{ width: 160 }}
            value={selectedSpeed}
            onChange={(e) =>
              updateReportConfigById(reportId, { speedHigh: Number(e.target.value) })
            }
          >
            {HIGH_SPEED_OPTIONS.map((speed) => (
              <option key={speed} value={speed}>
                {speed} Km/h
              </option>
            ))}
          </select>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <span>Tipo:</span>
          <select
            className="form-select"
            style={{ width: 240 }}
            value={selectedType}
            onChange={(e) =>
              updateReportConfigById(reportId, { typeHigh: Number(e.target.value) })
            }
          >
            {HIGH_SPEED_TYPE_OPTIONS.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  };

  const renderFreqAndExcel = (reportId) => (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: 28,
        alignItems: "flex-start",
        flexWrap: "wrap",
        marginLeft: CONTENT_INDENT,
        marginTop: 10,
      }}
    >
      {renderReportFrequencyControls(reportId)}
      {renderReportExcelControls(reportId)}
    </div>
  );

  const handleToggle = (key, checked) => {
    setRelatorios((prev) => ({ ...prev, [key]: checked }));
    updateReportConfigById(key, { ativo: checked });
  };

  // Padrão único de toggle: gap:12, minWidth:36 — mesmo usado em ReportRow
  const renderToggleRow = (id, label, checked, onChange, style = {}) => (
    <div style={{ display: "flex", alignItems: "center", gap: 12, ...style }}>
      <div className="form-check form-switch" style={{ minWidth: 36, margin: 0, padding: 0 }}>
        <input
          className="form-check-input"
          type="checkbox"
          id={`switch-${id}`}
          checked={checked}
          onChange={onChange}
          style={{ margin: 0 }}
        />
      </div>
      <label htmlFor={`switch-${id}`} style={{ fontWeight: 500, cursor: "pointer" }}>
        {label}
      </label>
    </div>
  );

  // Itens gerenciados pelo ReportConfigList (exclui os manuais)
  const listReportItems = React.useMemo(() => {
    return reportItems.filter((item) => !OTHER_REPORT_IDS.includes(item.id));
  }, [reportItems]);

  return (
    <div className="card col-md-12 p-3 mt-3">
      <h5 className="mb-3">Relatórios</h5>

      {/* ReportConfigList: posicionamento, atividades, trechos */}
      <div style={{ marginBottom: 16 }}>
        <ReportConfigList
          reportItems={listReportItems}
          initialConfig={initialReportConfig}
          onChange={(nextState) => {
            setReportConfigPayload((prev) => {
              const listReportItemIds = new Set(listReportItems.map((item) => item.id));
              const otherReports = prev.filter((item) => !listReportItemIds.has(item.id));

              const updatedListReports = Object.values(nextState).map((item) => ({
                id: item.id,
                ativo: item.ativo,
                frequencia: item.frequencia || FREQUENCIA.DIARIO,
                ...(item.tipoExcel ? { tipoExcel: item.tipoExcel } : {}),
              }));

              return [...otherReports, ...updatedListReports];
            });
          }}
          showPayloadPreview={false}
          renderItemContent={(reportItem, config) =>
            config?.ativo ? (
              <div style={{ marginLeft: CONTENT_INDENT, marginTop: 2 }}>
                {renderEmailManager(reportItem.id)}
              </div>
            ) : null
          }
        />
      </div>

      {/* Relatórios legados (ocultos por padrão) */}
      {SHOW_LEGACY_REPORTS ? (
        <div style={{ marginTop: 16 }}>
          {renderToggleRow(
            "pontoDeVista",
            "Envio de relatório de ponto de visita, controle e passagem",
            visitFlag,
            (e) => {
              handleToggle("pontoDeVista");
              setVisitFlag(e.target.checked);
            },
            { marginBottom: 10 }
          )}
          {relatorios.pontoDeVista ? (
            <div style={{ marginLeft: CONTENT_INDENT, marginTop: 2, marginBottom: 12 }}>
              {renderEmailManager("pontoDeVista")}
            </div>
          ) : null}

          {renderToggleRow(
            "areaDeRisco",
            "Envio de relatório de área de risco",
            riskAreaFlag,
            (e) => {
              handleToggle("areaDeRisco");
              setRiskAreaFlag(e.target.checked);
            },
            { marginBottom: 10 }
          )}
          {relatorios.areaDeRisco ? (
            <div style={{ marginLeft: CONTENT_INDENT, marginTop: 2, marginBottom: 12 }}>
              {renderEmailManager("areaDeRisco")}
            </div>
          ) : null}

          {renderToggleRow(
            "cercaEletronica",
            "Envio de relatório de condução em cerca eletrônica",
            fenceFlag,
            (e) => {
              handleToggle("cercaEletronica");
              setFenceFlag(e.target.checked);
            },
            { marginBottom: 10 }
          )}
          {relatorios.cercaEletronica ? (
            <div style={{ marginLeft: CONTENT_INDENT, marginTop: 2, marginBottom: 12 }}>
              {renderEmailManager("cercaEletronica")}
            </div>
          ) : null}
        </div>
      ) : null}

      {/* Relatórios manuais: visitas, velocidade, manutenção */}
      <div style={{ marginTop: 16 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>

          {/* Visitas por veículos */}
          <div>
            {renderToggleRow("visitsSummaryXlsPeriod", "Relatório de visitas por veículos XLS", !!relatorios.visitsSummaryXlsPeriod, (e) => handleToggle("visitsSummaryXlsPeriod", e.target.checked))}
            {relatorios.visitsSummaryXlsPeriod ? (
              <>
                {renderFreqAndExcel("visitsSummaryXlsPeriod")}
                <div style={{ marginLeft: CONTENT_INDENT, marginTop: 8 }}>
                  {renderEmailManager("visitsSummaryXlsPeriod")}
                </div>
              </>
            ) : null}

            {renderToggleRow("visitsSummaryPdfPeriod", "Relatório de visitas por veículos PDF", !!relatorios.visitsSummaryPdfPeriod, (e) => handleToggle("visitsSummaryPdfPeriod", e.target.checked), { marginTop: 8 })}
            {relatorios.visitsSummaryPdfPeriod ? (
              <>
                {renderReportFrequencyControls("visitsSummaryPdfPeriod")}
                <div style={{ marginLeft: CONTENT_INDENT, marginTop: 8 }}>
                  {renderEmailManager("visitsSummaryPdfPeriod")}
                </div>
              </>
            ) : null}
          </div>

          <hr style={{ margin: "8px 0" }} />

          {/* Veículos por visitas */}
          <div>
            {renderToggleRow("visitsAmountPdfPeriod", "Relatório de veículos por visitas PDF", !!relatorios.visitsAmountPdfPeriod, (e) => handleToggle("visitsAmountPdfPeriod", e.target.checked))}
            {relatorios.visitsAmountPdfPeriod ? (
              <>
                {renderReportFrequencyControls("visitsAmountPdfPeriod")}
                <div style={{ marginLeft: CONTENT_INDENT, marginTop: 8 }}>
                  {renderEmailManager("visitsAmountPdfPeriod")}
                </div>
              </>
            ) : null}

            {renderToggleRow("visitsAmountXlsPeriod", "Relatório de veículos por visitas XLS", !!relatorios.visitsAmountXlsPeriod, (e) => handleToggle("visitsAmountXlsPeriod", e.target.checked), { marginTop: 8 })}
            {relatorios.visitsAmountXlsPeriod ? (
              <>
                {renderFreqAndExcel("visitsAmountXlsPeriod")}
                <div style={{ marginLeft: CONTENT_INDENT, marginTop: 8 }}>
                  {renderEmailManager("visitsAmountXlsPeriod")}
                </div>
              </>
            ) : null}
          </div>

          <hr style={{ margin: "8px 0" }} />

          {/* Alta Velocidade */}
          <div>
            {renderToggleRow("speedSummaryPdfPeriod", "Resumo de alta velocidade em PDF", !!relatorios.speedSummaryPdfPeriod, (e) => handleToggle("speedSummaryPdfPeriod", e.target.checked))}
            {relatorios.speedSummaryPdfPeriod ? (
              <>
                {renderReportFrequencyControls("speedSummaryPdfPeriod")}
                {renderHighSpeedControls("speedSummaryPdfPeriod")}
                <div style={{ marginLeft: CONTENT_INDENT, marginTop: 8 }}>
                  {renderEmailManager("speedSummaryPdfPeriod")}
                </div>
              </>
            ) : null}

            {renderToggleRow("speedSummaryXlsPeriod", "Resumo de alta velocidade em XLS", !!relatorios.speedSummaryXlsPeriod, (e) => handleToggle("speedSummaryXlsPeriod", e.target.checked), { marginTop: 8 })}
            {relatorios.speedSummaryXlsPeriod ? (
              <>
                {renderFreqAndExcel("speedSummaryXlsPeriod")}
                {renderHighSpeedControls("speedSummaryXlsPeriod")}
                <div style={{ marginLeft: CONTENT_INDENT, marginTop: 8 }}>
                  {renderEmailManager("speedSummaryXlsPeriod")}
                </div>
              </>
            ) : null}
          </div>

          <hr style={{ margin: "8px 0" }} />

          {/* Manutenção */}
          <div>
            {renderToggleRow("maintenanceSummaryPdfPeriod", "Manutenção PDF", !!relatorios.maintenanceSummaryPdfPeriod, (e) => handleToggle("maintenanceSummaryPdfPeriod", e.target.checked))}
            {relatorios.maintenanceSummaryPdfPeriod ? (
              <>
                {renderReportFrequencyControls("maintenanceSummaryPdfPeriod")}
                <div style={{ marginLeft: CONTENT_INDENT, marginTop: 8 }}>
                  {renderEmailManager("maintenanceSummaryPdfPeriod")}
                </div>
              </>
            ) : null}

            {renderToggleRow("maintenanceSummaryXlsPeriod", "Manutenção XLS", !!relatorios.maintenanceSummaryXlsPeriod, (e) => handleToggle("maintenanceSummaryXlsPeriod", e.target.checked), { marginTop: 8 })}
            {relatorios.maintenanceSummaryXlsPeriod ? (
              <>
                {renderFreqAndExcel("maintenanceSummaryXlsPeriod")}
                <div style={{ marginLeft: CONTENT_INDENT, marginTop: 8 }}>
                  {renderEmailManager("maintenanceSummaryXlsPeriod")}
                </div>
              </>
            ) : null}
          </div>

        </div>
      </div>
    </div>
  );
}
